const AllPackages = [
  {
    name: 'Lit Homeworker',
    speed: '500Mb',
    productCode: 'O-LIT-FIBRE-500',
    bundleCode: 'B-LIT-HOMEWORKER-2502-12M',
    contract: '12Months',
  },
  {
    name: 'Lit Family',
    speed: '500Mb',
    productCode: 'O-LIT-FIBRE-500',
    bundleCode: 'B-LIT-FAMILY-2502-12M',
    contract: '12Months',
  },
  {
    name: 'Lit Gamer',
    speed: '1GB',
    productCode: 'O-LIT-FIBRE-1000',
    bundleCode: 'B-LIT-GAMER-2502-12M',
    contract: '12Months',
  },
  {
    name: 'Lit Ultimate',
    speed: '1GB',
    productCode: 'O-LIT-FIBRE-1000',
    bundleCode: 'B-LIT-ULTIMATE-2502-12M',
    contract: '12Months',
  },
  {
    name: 'Lit Homeworker',
    speed: '500Mb',
    productCode: 'O-LIT-FIBRE-500-18M',
    bundleCode: 'B-LIT-HOMEWORKER-2502-18M',
    contract: '18Months',
  },
  {
    name: 'Lit Family',
    speed: '500Mb',
    productCode: 'O-LIT-FIBRE-500-18M',
    bundleCode: 'B-LIT-FAMILY-2502-18M',
    contract: '18Months',
  },
  {
    name: 'Lit Gamer',
    speed: '1GB',
    productCode: 'O-LIT-FIBRE-1000-18M',
    bundleCode: 'B-LIT-GAMER-2502-18M',
    contract: '18Months',
  },
  {
    name: 'Lit Ultimate',
    speed: '1GB',
    productCode: 'O-LIT-FIBRE-1000-18M',
    bundleCode: 'B-LIT-ULTIMATE-2502-18M',
    contract: '18Months',
  },
  {
    name: 'Lit Homeworker',
    speed: '500Mb',
    productCode: 'O-LIT-FIBRE-500-24M',
    bundleCode: 'B-LIT-HOMEWORKER-2502-24M',
    contract: '24Months',
  },
  {
    name: 'Lit Family',
    speed: '500Mb',
    productCode: 'O-LIT-FIBRE-500-24M',
    bundleCode: 'B-LIT-FAMILY-2502-24M',
    contract: '24Months',
  },
  {
    name: 'Lit Gamer',
    speed: '1GB',
    productCode: 'O-LIT-FIBRE-1000-24M',
    bundleCode: 'B-LIT-GAMER-2502-24M',
    contract: '24Months',
  },
  {
    name: 'Lit Ultimate',
    speed: '1GB',
    productCode: 'O-LIT-FIBRE-1000-24M',
    bundleCode: 'B-LIT-ULTIMATE-2502-24M',
    contract: '24Months',
  },
];

const ValidContracts = [
  {
    id: '24Months',
    length: 24,
    title: '24 Months',
  },
  {
    id: '18Months',
    length: 18,
    title: '18 Months',
  },
  {
    id: '12Months',
    length: 12,
    title: '12 Months',
  },
];

exports.AllPackages = AllPackages;
exports.ValidContracts = ValidContracts;
